export default "__VITE_ASSET__DlwMmj8Z__"